/*
  Configurador de personalizacion.

  No calcula precios de venta: cada opcion es un producto componente real y el
  cobro sale de la suma de lineas del carrito. Lo que se muestra en pantalla es
  un avance de ese total.

  Para anadirlo todo de una vez se reutiliza el mecanismo que el tema ya usa
  para los "additional fee": product-form.js busca elementos
  .additional-fee__card.checked que contengan un .additional-fee-selected con
  el id de variante, los manda en la misma operacion de anadir al carrito y
  agrupa las lineas con la propiedad _item_id. El carrito ya oculta las lineas
  hijas y mueve cantidades y borrados en bloque, asi que aqui solo hay que
  publicar esa estructura y dejar que el tema haga el resto.
*/
document.addEventListener('alpine:init', () => {
  Alpine.data('xPersonalizar', (sectionId, precioInicial, formatoMoneda) => ({
    grupos: [],
    /** id de grupo -> indice de la opcion elegida */
    elegido: {},
    /** id de grupo -> texto escrito por el cliente */
    texto: {},
    precioBase: precioInicial,

    init() {
      const fuente = this.$el.querySelector('[data-personalizar-config]');
      try {
        this.grupos = JSON.parse(fuente.textContent) || [];
      } catch (e) {
        console.warn('Configurador: metafield ilegible', e);
        this.grupos = [];
        return;
      }
      // Por defecto no se anade nada: la primera opcion de cada grupo es el "sin".
      this.grupos.forEach((g) => { this.elegido[g.id] = 0; this.texto[g.id] = ''; });

      // El precio base cambia al cambiar de talla, y el resumen debe seguirlo.
      const alCambiarVariante = (e) => {
        const v = e.detail && e.detail.currentVariant;
        if (v && typeof v.price === 'number') this.precioBase = v.price;
      };
      document.addEventListener(`maximize:variant-picker:updated:${sectionId}`, alCambiarVariante);
      document.addEventListener(`maximize:color-swatch:change:${sectionId}`, alCambiarVariante);
    },

    opcionDe(g) {
      return g.opciones[this.elegido[g.id] || 0] || g.opciones[0];
    },

    elegir(g, i) {
      this.elegido[g.id] = i;
      // Al volver a "sin", el dato que se habia escrito deja de tener sentido,
      // y lo que colgaba de esta eleccion tampoco puede quedarse elegido.
      if (!this.opcionDe(g).variante) {
        this.texto[g.id] = '';
        this.grupos.forEach((h) => {
          if (h.depende === g.id) { this.elegido[h.id] = 0; this.texto[h.id] = ''; }
        });
      }
    },

    /**
     * Un grupo que cuelga de otro -grabar la segunda cara- no se ensena hasta
     * que se ha elegido el primero: de otro modo la ficha abre con cuatro
     * bloques de grabacion casi identicos.
     */
    visible(g) {
      if (!g.depende) return true;
      const padre = this.grupos.find((h) => h.id === g.depende);
      return !!(padre && this.opcionDe(padre).variante);
    },

    /** Un grupo pide dato solo cuando esta elegida una opcion real. */
    pideTexto(g) { return g.pide === 'texto' && !!this.opcionDe(g).variante && this.visible(g); },
    pideArchivo(g) { return g.pide === 'archivo' && !!this.opcionDe(g).variante && this.visible(g); },

    /** Como se llama la propiedad que vera el cliente y el taller en el pedido. */
    nombreDato(g) {
      if (g.id.indexOf('placa') === 0) return 'Texto de la placa';
      if (g.id.indexOf('grabacion_texto') === 0) return g.id.slice(-1) === '2' ? 'Texto (2ª cara)' : 'Texto a grabar';
      return g.titulo;
    },

    /**
     * Las propiedades visibles del producto principal: solo lo que se ha elegido.
     * Dos grupos pueden compartir titulo -"Estuche" vale para placas y para
     * medallas-, y dos properties con el mismo nombre se pisan en el carrito, asi
     * que al repetido se le anade su titulo de grupo.
     */
    propiedades() {
      const p = [];
      const vistos = {};
      this.grupos.forEach((g) => {
        const o = this.opcionDe(g);
        if (!o.variante || !this.visible(g)) return;
        let n = g.titulo;
        if (vistos[n]) n = n + ' · ' + g.id.replace(/_/g, ' ');
        vistos[n] = true;
        // "Estuche 6008 · ø 70 y 50 mm (6008)" repite la referencia: solo se
        // anade cuando no esta ya en el nombre.
        const ref = o.ref && o.etiqueta.indexOf(o.ref) < 0 ? ' (' + o.ref + ')' : '';
        p.push({ k: g.id, n: n, v: o.etiqueta + ref });
      });
      return p;
    },

    /** Ids de variante de los componentes elegidos, en el formato que espera el tema. */
    variantes() {
      return this.grupos
        .filter((g) => this.visible(g))
        .map((g) => this.opcionDe(g).variante)
        .filter(Boolean);
    },

    /** Suplemento en centimos de lo elegido. */
    get suplemento() {
      return this.grupos.reduce(
        (s, g) => s + (this.visible(g) ? Math.round((this.opcionDe(g).precio || 0) * 100) : 0), 0);
    },

    get hayAlgo() { return this.suplemento > 0 || this.variantes().length > 0; },

    resumenGrupo(g) {
      const o = this.opcionDe(g);
      return o.variante ? o.etiqueta : '';
    },

    dinero(centimos) {
      return formatearMoneda(centimos, formatoMoneda);
    },
  }));
});

/**
 * Formatea centimos con el patron de la tienda ({{amount_with_comma_separator}}
 * y demas). Se pasa desde Liquid para no dar por hecho euros ni el idioma.
 */
function formatearMoneda(centimos, formato) {
  const valor = (centimos || 0) / 100;
  const patron = /\{\{\s*(\w+)\s*\}\}/;
  const m = (formato || '').match(patron);
  if (!m) return valor.toFixed(2);

  const separa = (num, miles, decimal) => {
    const partes = num.toFixed(2).split('.');
    partes[0] = partes[0].replace(/\B(?=(\d{3})+(?!\d))/g, miles);
    return partes[0] + decimal + partes[1];
  };
  let texto;
  switch (m[1]) {
    case 'amount_no_decimals':               texto = String(Math.round(valor)).replace(/\B(?=(\d{3})+(?!\d))/g, ','); break;
    case 'amount_with_comma_separator':      texto = separa(valor, '.', ','); break;
    case 'amount_no_decimals_with_comma_separator':
      texto = String(Math.round(valor)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'); break;
    case 'amount_with_apostrophe_separator': texto = separa(valor, "'", '.'); break;
    default:                                 texto = separa(valor, ',', '.');
  }
  return formato.replace(patron, texto);
}
